<template>
    <AppSection :title="params.information?.title || ''">
        <template #body>
            <div class="partners-list" v-if="params.list">
                <PartnersListItem v-for="(item, key) in params.list" :item="item" :key="key"/>
            </div>
        </template>
    </AppSection>
</template>

<script>
import PartnersListItem from "./PartnersListItem";
import AppSection from "../../AppSection";

export default {
    name: 'PartnersList',
    components: {AppSection, PartnersListItem},
    props: {
        params: {
            type: Object,
            default: () => {
                return {
                    list: []
                }
            }
        }
    },
}
</script>

<style lang="scss" scoped>
.partners-list {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    grid-gap: 30px;

    @include tablet {
        grid-template-columns: repeat(3, 1fr);
        grid-gap: 32px 20px;
    }

    @include mobile {
        grid-template-columns: repeat(2, 1fr);
        grid-gap: 18px 24px;
    }
}
</style>